<template>
	<div class="breakdown">
		<div class="row">
			<div class="col-md-12">
				<div class="ui-widget-container">
					<div class="row hidden-xs hidden-sm flush-top">
						<div class="col-md-6 flush-left-responsive">
							<ul class="pull-left inline nav com-mod-tab-module">
								<li :class="{ active: isEquityActive }" @click="changeActiveTab('equity')">
									<h3 class="com-mod-tab-module-header">Equities Breakdown</h3>
								</li>
								<li :class="{ active: isBondActive }" @click="changeActiveTab('bond')">
									<h3 class="com-mod-tab-module-header">Bonds Breakdown</h3>
								</li>
							</ul>
						</div>
					</div>
					<div
						class="row visible-xs visible-sm"
						:class="{ active: isEquityActive }"
						@click="changeActiveTab('equity')"
					>
						<div class="col-md-12">
							<div class="com-mod-accord-btn active label-with-icon">
								<div :class="[isEquityActive ? 'white-arrow-down' : 'white-arrow-right']" />
								<h3>Equities Breakdown</h3>
							</div>
						</div>
					</div>
					<div
						v-if="isBondActive"
						class="row visible-xs visible-sm"
						:class="{ active: isBondActive }"
						@click="changeActiveTab('bond')"
					>
						<div class="col-md-12">
							<div class="com-mod-accord-btn active label-with-icon">
								<div class="white-arrow-down" />
								<h3>Bonds Breakdown</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isBondActive">
			<div class="row">
				<div class="col-md-6">
					<div class="row">
						<div class="col-md-12">
							<h4 class="com-mod-section-header">Bond Details</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-4">
							<div class="row">
								<div class="col-md-12">
									<img class="breakdown-chart" :src="bondBreakdownData.bondBreakdownChart">
								</div>
								<div class="col-md-12">
									<div class="chart-title">Total bond holdings</div>
								</div>
							</div>
						</div>
						<div class="col-sm-8">
							<div class="row">
								<div class="col-md-12">
									<div v-if="checkForData(bondBreakdownData.sectors)">
										<breakdown-table :module-data="bondBreakdownData.sectors">
											<template #superscript1a>
												<disclosure-superscript
													class="detail-page"
													anchor="bondEquity_cashEquivalents"
													:statistics="['PS_CE']"
												/>
											</template>
											<template #superscript1b>
												<disclosure-superscript
													class="detail-page"
													anchor="bondEquity_cashEquivalents"
													:statistics="['PS_CE']"
												/>
											</template>
										</breakdown-table>
										<div
											class="sub-info"
										>% of net assets as of {{ bondBreakdownData.sectors.asOfDate }} (updated monthly)</div>
									</div>
									<div v-else>
										<span class="com-mod-table-label">No bond details data is avaliable at this time.</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row">
						<div class="col-md-12">
							<h4 class="com-mod-section-header">
								Top Fixed-Income Issuers
								<disclosure-superscript
									class="detail-page"
									anchor="bondEquity_topFixed"
									:statistics="['TopHLD']"
								/>
							</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div v-if="checkForData(bondBreakdownData.holdings)">
								<blue-bar-table
									:module-data="{data: bondBreakdownData.holdings.data, includeDataField: true }"
								/>
								<div
									class="sub-info adjust-date"
								>% of net assets as of {{ bondBreakdownData.holdings.asOfDate }} (updated monthly)</div>
							</div>
							<div v-else>
								<span class="com-mod-table-label">No top issuers data is avaliable at this time.</span>
							</div>
						</div>
						<div v-if="isAuthorizedModule['detailsBreakdownEquityAndBondQuarterlyHoldingsLink']" id="_detailsBreakdownEquityAndBondQuarterlyHoldingsLink">
							<div class="col-md-12">
								<div class="link-container">
									<i class="afis-icon-arrow-right" />
									<a :href="quarterlyHoldingsLink">
										QUARTERLY HOLDINGS
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="row">
				<div class="col-md-6">
					<div class="toggle-section-header">
						<a
							class="sub-header"
							href="javascript:void(0)"
							:class="{active: isSector}"
							@click="toggle('sector')"
						>Sectors</a> |
						<a
							class="sub-header"
							href="javascript:void(0)"
							:class="{active: !isSector}"
							@click="toggle('industry')"
						>Top Industries</a>
					</div>
					<div class="row adjust-down">
						<div v-if="isSector" class="col-sm-4">
							<div class="row">
								<div class="col-md-12">
									<img class="breakdown-chart" :src="equityBreakdownData.equityBreakdownChart">
								</div>
								<div class="col-md-12">
									<div class="chart-title">Equity Fund Holdings</div>
								</div>
							</div>
						</div>
						<div :class="[ {'col-sm-8': isSector}, 'col-sm-12' ]">
							<div class="row">
								<div class="col-md-12">
									<div v-if="isSector">
										<div v-if="checkForData(equityBreakdownData.sectors)">
											<breakdown-table :module-data="equityBreakdownData.sectors" />
											<div
												class="sub-info"
											>% of net assets as of {{ equityBreakdownData.sectors.asOfDate }} (updated monthly)</div>
										</div>
										<div v-else>
											<span class="com-mod-table-label">No sectors data is avaliable at this time.</span>
										</div>
									</div>
									<div v-else>
										<div v-if="checkForData(equityBreakdownData.industries)">
											<blue-bar-table
												:module-data="{data: equityBreakdownData.industries.data, includeDataField: true }"
											/>
											<div
												class="sub-info adjust-date"
											>% of net assets as of {{ equityBreakdownData.industries.asOfDate }} (updated monthly)</div>
										</div>
										<div v-else>
											<span class="com-mod-table-label">No top industries data is avaliable at this time.</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row">
						<div class="col-md-12">
							<h4 class="com-mod-section-header">
								Top Equities
								<disclosure-superscript
									class="detail-page"
									anchor="bondEquity_topEquity"
									:statistics="['TopHLD']"
								/>
							</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div v-if="checkForData(equityBreakdownData.holdings)">
								<blue-bar-table
									:module-data="{data: equityBreakdownData.holdings.data, includeDataField: true }"
								/>
								<div
									class="sub-info adjust-date"
								>% of net assets as of {{ equityBreakdownData.holdings.asOfDate }} (updated monthly)</div>
							</div>
							<div v-else>
								<span class="com-mod-table-label">No top equities data is avaliable at this time.</span>
							</div>
						</div>
						<div class="col-md-12">
							<div class="link-container">
								<i class="afis-icon-arrow-right" />
								<a :href="quarterlyHoldingsLink">
									QUARTERLY HOLDINGS
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="ui-widget-container">
							<div
								v-if="isEquityActive"
								class="row visible-xs visible-sm"
								:class="{ active: isBondActive }"
								style="margin-left: 13px;"
								@click="changeActiveTab('bond')"
							>
								<div class="com-mod-accord-btn active label-with-icon">
									<div class="white-arrow-right" />
									<h3>Bonds Breakdown</h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreakdownTable from '_components_/global/BreakdownTable';
import BlueBarTable from '_components_/global/BlueBarTable';
export default {
	name: 'BreakdownEquityandBond',
	components: {
		BreakdownTable,
		BlueBarTable
	},
	props: {
		equityBreakdownData: {
			type: Object,
			defult: null
		},
		bondBreakdownData: {
			type: Object,
			defult: null
		}
	},
	data() {
		this.isEquityAndBond = false;
		this.isBondActive = false;
		this.isSector = true;
		this.isIndustry = false;
		return {
			isSector: this.isSector,
			isIndustry: this.isIndustry,
			isEquityActive: !this.isBondActive,
			isBondActive: this.isBondActive
		};
	},
	computed: {
		...mapGetters([
			'sectorExposure_asOfDate',
			'sectorExposure_data',
			'sectorExposure_chart'
		])
	},
	watch: {
		equityBreakdownData: {
			immediate: true,
			handler(val) {
				this.updateExcelData(val, null);
			}
		},
		bondBreakdownData: {
			immediate: true,
			handler(val) {
				this.updateExcelData(null, val);
			}
		}
	},
	methods: {
		checkForData(arr) {
			return arr && arr.data && arr.data.length > 0;
		},
		toggle(string) {
			if (string === 'sector') {
				this.isSector = true;
				this.isIndustry = false;
			} else {
				this.isSector = false;
				this.isIndustry = true;
			}
		},
		changeActiveTab(activeTab) {
			if (activeTab === 'equity') {
				this.isEquityActive = true;
				this.isBondActive = false;
			}
			if (activeTab === 'bond') {
				this.isEquityActive = false;
				this.isBondActive = true;
			}
		},
		updateExcelData(equityBreakdownData, bondBreakdownData) {
			if (!equityBreakdownData) {
				equityBreakdownData = this.equityBreakdownData || {};
			}
			if (!bondBreakdownData) {
				bondBreakdownData = this.bondBreakdownData || {};
			}
			this.$EventBus.$emit('ExcelData', 'EquitiesBreakdownModule', {
				sectorsAsOfDate: `% of net assets as of ${(equityBreakdownData.sectors &&
					equityBreakdownData.sectors.asOfDate) ||
					'--'} (updated monthly)`,
				sectorsData: equityBreakdownData.sectors,
				topIndustriesAsOfDate: `% of net assets as of ${equityBreakdownData.industries &&
					equityBreakdownData.industries.asOfDate} (updated monthly)`,
				topIndustries: equityBreakdownData.industries,
				topEquitiesAsOfDate: `% of net assets as of ${(equityBreakdownData.holdings &&
					equityBreakdownData.holdings.asOfDate) ||
					'--'} (updated monthly)`,
				topEquities:
					equityBreakdownData.holdings &&
					equityBreakdownData.holdings.data
			});
			this.$EventBus.$emit('ExcelData', 'BondsBreakdownModule', {
				bondDetailAsOfDate: `% of net assets as of ${bondBreakdownData.sectors &&
					bondBreakdownData.sectors.asOfDate} (updated monthly)`,
				topIssuersAsOfDate: `% of net assets as of ${bondBreakdownData.holdings &&
					bondBreakdownData.holdings.asOfDate} (updated monthly)`,
				bonds: bondBreakdownData.sectors,
				topIssuers: bondBreakdownData.holdings
			});
		}
	}
};
</script>

<style lang="less" scoped>
@import '~_css_/breakdown-module.less';
</style>
